// extracted by mini-css-extract-plugin
export default {"container":"newTemplate_container__XOW3h","emoji":"newTemplate_emoji__iecS8"};